import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Table from './Table';
import './Table.scss';

const OverviewTable = ({additionalClassNames, children, tableId}) => {
    const tableClassName = classNames(
        "col-xs-12",
        "table",
        "table-details",
        additionalClassNames
    );
    return(
        <Table
            className={tableClassName}
            htmlId={tableId}>
            {children}
        </Table>
    );
};

OverviewTable.propTypes = {
    additionalClassNames: PropTypes.string,
    children: PropTypes.node,
    tableId: PropTypes.string
};

export default OverviewTable;


// WEBPACK FOOTER //
// ./src/components/base/Table/OverviewTable.js